import "./App.css";
import chat from "./assets/images/chat.png";
import logo from "./assets/images/logo2.png";
import doctor from "./assets/images/doctors.png";
import doctor2 from "./assets/images/doctor2.png";
import one1 from "./assets/images/one1.png";
import one2 from "./assets/images/one2.png";
import one3 from "./assets/images/one3.png";
import one4 from "./assets/images/one4.png";
import one5 from "./assets/images/one5.png";
import one6 from "./assets/images/one6.png";
import icon1 from "./assets/images/icon1.png";
import icon2 from "./assets/images/icon2.png";
import icon3 from "./assets/images/icon3.png";
import icon4 from "./assets/images/icon4.png";
import img1 from "./assets/images/img1.png";
import img2 from "./assets/images/img2.png";
import img3 from "./assets/images/img3.png";
import img4 from "./assets/images/img4.png";
import { FaYoutube, FaFacebook, FaTiktok, FaInstagram } from "react-icons/fa";
import { useState } from "react";

function App() {
  const [show, setshow] = useState(false);

  let work;

  const change = () => {
    setshow(!show);
  };
  if (show) {
    work = "show";
  } else {
    work = "hide";
  }

  return (
    <div className="App">
      <header>
        <nav>
          <img className="logo" src={logo} alt="" />
          <div className="toggle" onClick={change}>
            &#9776;
          </div>
          <ul className={work}>
            <li className="home">Home</li>
            <li>About Us</li>
            <li>Features</li>
            <li>Audience</li>
            <li>Benefits</li>
            <li>FAQ</li>
            <button>Log in</button>
          </ul>
        </nav>

        <div className="header-content">
          <div className="header-text">
            <h1>Tired of Wasting Hours Digging Through Regulations?</h1>
            <p>
              If you’re an administrator, clinician, physician, or nurse in
              long-term care, you already know: Compliance isn’t opillucitly
              confusing changing.Regulations are dense, concussing, and
              constantly changing—you’re held readver.
            </p>
            <button className="one">Start Free Trial</button>
            <button className="two">Login</button>
          </div>
          <img className="doctor" src={doctor} alt="" />
        </div>
        <img className="chat" src={chat} alt="" />
      </header>
      
      <section className="section-two">
        <img className="one1" src={one1} alt="" />
        <img className="one2" src={one2} alt="" />
        <img className="one3" src={one3} alt="" />
        <img className="one4" src={one4} alt="" />
        <img className="one5" src={one5} alt="" />
        <img className="one6" src={one6} alt="" />
      </section>

      <main>
        <h2>What You Can Do in Seconds (Not Hours)</h2>
        <div className="main-content">
          <div>
            <img className="icons" src={icon1} alt="" />
            <h3>Ask Any Compliance Question</h3>
            <p>
              Type or speak in plain English. Get AI-powered, regulation-based
              answers instantly.
            </p>
          </div>
          <div>
            <img className="icons" src={icon2} alt="" />
            <h3>Chat with a Smart Compliance Assistant</h3>
            <p>
              No more second-guessing. Clarify policies, get summaries, and
              understand what applies to you.
            </p>
          </div>
          <div>
            <img className="icons" src={icon3} alt="" />
            <h3>Get Role-Specific Guidance</h3>
            <p>
              Whether you’re a physician or an RN, your answers are tailored to
              your role.
            </p>
          </div>
          <div>
            <img className="icons" src={icon4} alt="" />
            <h3>Spot Risk Before It’s a Problem</h3>
            <p>
              Describe a scenario, and get an instant deficiency risk level—plus
              a sample Plan of Correction.
            </p>
          </div>
        </div>
      </main>

      <section className="section-four">
        <img src={chat} alt="" />
        <div className="text">
          <h2>Who It’s For</h2>
          <div className="first">
            <li>Nurses:</li>
            <p>
              Tired of hunting for documentation mid-shift.
              <span>01</span>
            </p>
          </div>

          <div className="second">
            <li>Administrators:</li>
            <p>
              <span>02</span> Trying to stay audit-ready
            </p>
          </div>

          <div className="third">
            <li>Physicians:</li>
            <p>
              Juggling multiple roles. <span>03</span>
            </p>
          </div>
          <div className="fourth">
            <li>Clinicians:</li>
            <p>
              <span>04</span>Who want fast, confident answers.
            </p>
          </div>
          <button>Contact Us</button>
        </div>
      </section>

      <section>
        <div className="section-five">
          <h2>Results You’ll Feel Immediately</h2>
          <p>
            Experience the transformative impact of an AI-powered compliance
            assistant.
          </p>
        </div>
        <div className="results">
          <div>
            <img src={img1} alt="" />
            <h3>Make Faster Decisions</h3>
            <p>50% faster decisions compliance questions.</p>
          </div>
          <div>
            <img src={img2} alt="" />
            <h3>Save Time Every Week</h3>
            <p>5+ hours saved each week.</p>
          </div>
          <div>
            <img src={img3} alt="" />
            <h3>Reduce Audit Stress</h3>
            <p>Less stress during audits and inspections.</p>
          </div>
          <div>
            <img src={img4} alt="" />
            <h3>Enjoy Peace of Mind</h3>
            <p>Peace of mind knowing you’re covered..</p>
          </div>
        </div>

        <div className="numbers">
          <div className="number">
            <div>
              <h2>12K+</h2>
              <p>Regulations Indexed</p>
            </div>
            <div>
              <h2>99%+</h2>
              <p>Accuracy in Compliance Guidance</p>
            </div>
            <div>
              <h2>5+</h2>
              <p>Hours Saved Weekly</p>
            </div>
            <div>
              <h2>50%</h2>
              <p>Reduction in Manual Searches</p>
            </div>
          </div>
        </div>
      </section>

      <section className="checks">
        <div className="check">
          <div className="firsts">
            <h1>All-In-One Plan</h1>
            <p>
              Discover the ideal plan to fuel your business growth. Our pricing
              options are carefully crafted to cater to businesses.
            </p>
          </div>

          <div className="aside">
            <div className="aside-one">
              <h2>Pro</h2>
              <p>Unleash the Power of Your Business with Pro Plan.</p>
              <h2>$29</h2>
              <hr />
              <li>✔ AI-powered search — ask questions in plain English</li>
              <li>
                ✔ Role-specific guidance for nurses, admins, clinicians & more
              </li>
              <li>✔ Smart chat assistant available 24/7</li>
              <li>✔ Case assessment + deficiency risk prediction</li>
              <li>✔ Alerts when regulations change</li>
              <button> Get Started </button>
            </div>

            <div className="aside-two">
              <h2>Business</h2>
              <p>Take Your Business the Next Level Business Plan.</p>
              <h2>$290</h2>
              <hr />

              <li>✔ AI-powered search — ask questions in plain English</li>
              <li>
                ✔ Role-specific guidance for nurses, admins, clinicians & more
              </li>
              <li>✔ Smart chat assistant available 24/7</li>
              <li>✔ Case assessment + deficiency risk prediction</li>
              <li>✔ Alerts when regulations change</li>
              <button> Get Started </button>
            </div>
          </div>
        </div>
      </section>

      <section className="freq">
        <h2>Frequently asked questions</h2>
        <div className="sec">
          <div className="freq1">
            <div>
              <div className="freqltc">
                <h4>What is LTC-Reg 360, and how does it work?</h4> x
              </div>
              <p>
                LTC-Reg 360 is an AI-powered compliance assistant designed for
                healthcare professionals. It provides instant answers to
                compliance questions, tailored guidance based on your role, and
                tools to reduce stress during audits and inspections.
              </p>
            </div>
          </div>
          <div className="freq2">
            <div>
              <h4>Who can benefit from using LTC-Reg 360?</h4> +
            </div>
            <div>
              <h4>How do I start a free trial?</h4> +
            </div>
            <div>
              <h4>Is my data secure with LTC-Reg 360?</h4> +
            </div>
            <div>
              <h4>What kind of questions can the AI assistant answer?</h4> +
            </div>
            <div>
              <h4>Can I access LTC-Reg 360 on my mobile device?</h4> +
            </div>
          </div>
        </div>
      </section>

      <section className="doctor2">
        <div className="doctors">
          <div>
            <h1>Try LTC-Reg 360 Today</h1>
            <p>The AI Compliance Assistant Built for You.</p>
            <button className="btn1">Start Your Free Trial</button>
            <button className="btn2">Watch In Action</button>
          </div>

          <img src={doctor2} alt="" />
        </div>
      </section>

      <footer>
        <div className="wrapper">
          <div className="footer1">
            <img className="logo" src={logo} alt="" />
            <p>
              If you’re an administrator, clinician, physician, or nurse in
              long-term care, you already know
            </p>

            <h2>Follow Us</h2>
            <FaFacebook size="25" color="white" className="fonts" />
            <FaInstagram size="25" color="white" className="fonts" />
            <FaYoutube size="25" color="white" className="fonts" />
            <FaTiktok size="25" color="white" className="fonts" />
          </div>

          <div>
            <h4>Quick Links</h4>
            <li>Home</li>
            <li>About Us</li>
            <li>Features</li>
            <li>Audience</li>
            <li>FAQ</li>
          </div>

          <div>
            <h4>Services</h4>
            <li>Nurses</li>
            <li>Administrators</li>
            <li>Physicians</li>
            <li>Clinicians</li>
          </div>

          <div>
            <h4>Contact Us</h4>
            <li>1234 LTC- REG360 Ai Drive, Suite 500 3C3, Canada</li>
            <li>contact@ltcreg360ai.com</li>
            <li>(123) 456-7890</li>
          </div>
        </div>
        <hr />
        <h3>© 2025 LTC- REG 360 Ai. All Rights Reserved.</h3>
      </footer>
    </div>
  );
}

export default App;
